import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import './firebase'
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/css/bootstrap.css'

import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store/Store'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
)
reportWebVitals()
